// src/pages/ResetMfa.jsx
import { Box, Heading, Link, ListItem, Text, UnorderedList } from "@chakra-ui/react";

export default function ResetMfa() {
  return (
    <Box p={4}>
      <Heading as="h2" size="md" mb={4}>
        Reset MFA
      </Heading>

      <Text mb={4}>
        If you need to reset your MFA, please send an email to{" "}
        <Link href="mailto:cyber@lognpacific.com" color="blue.500" textDecor="underline">
          cyber@lognpacific.com
        </Link>{" "}
        with the subject line: <b>"MFA Reset Request"</b>.
      </Text>

      <Text mb={3}>When you email us, please include:</Text>
      <UnorderedList mb={6} pl={6}>
        <ListItem>Your name</ListItem>
        <ListItem>Your <b>Skool-registered email address</b></ListItem>
      </UnorderedList>

      <Text>
        Tip: After we reset your MFA, you can set it up again using{" "}
        Google Authenticator, Microsoft Authenticator, or SMS. We generally recommend{" "}
        <b>Google Authenticator</b> for fewer issues.
      </Text>
    </Box>
  );
}
